/** Discovery-call booking link (Google Calendar booking page, Cal.com, Calendly, etc.). */
export function getBookingUrl(): string | null {
  const url = (import.meta.env.VITE_BOOKING_URL as string | undefined)?.trim()
  return url || null
}
